import React from 'react';
import { Truck, Globe, Users, Award } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Globe,
      title: 'Global Import/Export',
      description: 'Comprehensive international trading services connecting UK businesses with global markets and suppliers.'
    },
    {
      icon: Truck,
      title: 'Product Sourcing',
      description: 'Expert product sourcing and procurement services ensuring quality products at competitive prices.'
    },
    {
      icon: Users,
      title: 'Retail Support',
      description: 'End-to-end retail support services helping businesses optimize their operations and growth.'
    },
    {
      icon: Award,
      title: 'Quality Assurance',
      description: 'Rigorous quality control processes ensuring every product meets the highest standards.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">About Mitz Traders</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A leading UK-based trading and e-commerce company committed to delivering excellence 
            in global trade, customer service, and business partnerships.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Who We Are</h3>
            <p className="text-lg text-gray-600 mb-6">
              Mitz Traders is a dynamic UK-based trading and e-commerce company specialising in 
              import/export services, product sourcing, and comprehensive retail support. We bridge 
              the gap between global suppliers and UK businesses, ensuring seamless trade relationships 
              and exceptional service delivery.
            </p>
            <p className="text-lg text-gray-600 mb-6">
              Our commitment to reliability, fast delivery, and a customer-first approach has made us 
              a trusted partner for businesses across various industries. Through our flagship platform 
              MitzCart.com, we've revolutionized online retail experiences in the UK market.
            </p>
          </div>
          
          <div className="relative">
            <img 
              src="https://images.unsplash.com/photo-1568992687947-868a62a9f521?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjB0ZWFtfGVufDB8fHx8MTc1MzI0MjczMHww&ixlib=rb-4.1.0&q=85"
              alt="Professional team meeting"
              className="rounded-lg shadow-lg w-full h-80 object-cover"
            />
            <div className="absolute inset-0 bg-blue-600 bg-opacity-10 rounded-lg"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="text-center p-6 rounded-lg border border-gray-100 hover:shadow-lg transition-shadow duration-200"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 text-blue-600 rounded-full mb-4">
                <feature.icon size={32} />
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h4>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;